export enum OOFProvidersEnum {
    EARTHLINK = 'earthlink',
    CONSOLIDATED = 'consolidated',
    BRIGHTSPEED = 'brightspeed',
    ALTAFIBER = 'altafiber',
    HAWAIIAN_TELECOM = 'hawaiiantelcom',
    ZIPLY = 'ziply',
    FRONTIER = 'frontier',
    CHARTER = 'charter',
    SPECTRUM = 'spectrum',
    VIASAT = 'viasat',
    WINDSTREAM = 'windstream',
    OPTIMUM = 'optimum',
    WOW = 'wow',
    HUGHESNET = 'hughesnet',
    METRONET = 'metronet',
}
